import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import ReactGA from 'react-ga4';
import { routerMiddleware } from 'react-router-redux';
import { googleAnalytics } from './../googleAnalytics';
import rootReducer from '../reducers';
import config from '../../config';

export default function configureStore(initialState = {}, history) {
  ReactGA.initialize(config.get('gaID'), { debug: false });
  let devToolsExtension = f => f;
  if (config.get('server') === 'development') {
    devToolsExtension = window.devToolsExtension ? window.devToolsExtension() : f => f;
  }
  return createStore(
    rootReducer,
    initialState,
    compose(
      applyMiddleware(thunk, routerMiddleware(history)),
      applyMiddleware(googleAnalytics),
      devToolsExtension,
    ),
  );
}



// WEBPACK FOOTER //
// ./src/store/configureStore.js